var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
export class SportParser {
    constructor(retrievers, messageBus, channelPrefix) {
        this.disposer = () => { };
        this.messageBus = messageBus;
        this.retrievers = retrievers;
        this.channelPrefix = channelPrefix;
        this.isActive = false;
    }
    activate(state) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isActive = true;
            yield Promise.all(this.retrievers.map((r) => __awaiter(this, void 0, void 0, function* () {
                return yield r.activate(state);
            })));
            this.disposer = state.Items.observe(this.onSportItemsChange.bind(this), true);
            if (this.isActive) {
                state.selectInitial();
            }
        });
    }
    deactivate() {
        this.isActive = false;
        this.retrievers.forEach(r => r.deactivate());
        this.disposer();
    }
    getCountUpdateChannel() {
        return `${this.channelPrefix}.${InternalMessageBusChannels.eventsList.count}`;
    }
    onSportItemsChange(change) {
        const channel = this.getCountUpdateChannel();
        if (change.type === "splice") {
            change.added.forEach((add) => {
                this.messageBus.emit(channel, { eventsCount: add.numberOfEvents, sportId: add.id });
            });
            change.removed.forEach((removed) => {
                this.messageBus.emit(channel, { eventsCount: 0, sportId: removed.id });
            });
        }
        else { // type == update
            if (change.oldValue.numberOfEvents !== change.newValue.numberOfEvents) {
                this.messageBus.emit(channel, { eventsCount: change.newValue.numberOfEvents, sportId: change.newValue.id });
            }
        }
    }
}
//# sourceMappingURL=SportParser.js.map